
import React from 'react';
import { Building, Droplets, FileText, Box, Space } from 'lucide-react';
import { PortfolioType } from '@/types/portfolio';

export const getPortfolioTypeIcon = (type: string) => {
  switch (type) {
    case 'buildings':
      return <Building className="h-5 w-5 mr-2" />;
    case 'formulated_products':
      return <Droplets className="h-5 w-5 mr-2" />;
    case 'interior_spaces':
      return <Space className="h-5 w-5 mr-2" />;
    case 'paper_rolls':
      return <FileText className="h-5 w-5 mr-2" />;
    default:
      return <Box className="h-5 w-5 mr-2" />;
  }
};

export const getItemTypeName = (portfolioType: PortfolioType): string => {
  switch (portfolioType) {
    case 'buildings':
      return 'Building';
    case 'formulated_products':
      return 'Product';
    case 'interior_spaces':
      return 'Space';
    case 'paper_rolls':
      return 'Paper Roll';
    default:
      return 'Item';
  }
};
